import * as AspectRatioPrimitive from "@radix-ui/react-aspect-ratio"

/**
 * Displays content within a desired ratio.
 */
const AspectRatio = AspectRatioPrimitive.Root

export { AspectRatio }
